import { environment } from '@environments/environment';
import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '@app/services/auth/auth.service';
import { map, take } from 'rxjs/operators';


export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const cookieService = inject(CookieService);
  const platformId = inject(PLATFORM_ID);
  const authService = inject(AuthService);
  
  // Check if user is authenticated via Cognito
  const isCognitoAuthenticated = authService.isAuthenticated();
  
  if (isCognitoAuthenticated) {
    // User is authenticated via Cognito SSO
    return true;
  }
  
  // Fall back to idaas oidc cookie-based authentication
  const jwt = cookieService.get(environment.jwtCookieName);

  if (!jwt) {
    if (isPlatformBrowser(platformId)) {
      window.location.href = environment.signUpUrl;
    }
    return false;
  }

  const tokenExpiration = JSON.parse(atob(jwt.split('.')[1])).exp;

  if (Date.now() < tokenExpiration * 1000) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
